<div class="control-section row">
  <div id="wrapper" class="col-12">
    <app-header></app-header>
    <div class="main-content" id="maintext">
      <div id="sidebar-section">
        <app-left-navigation></app-left-navigation>
        <div class="sidebar-menu-content">
          <div id="dynamicScroll" class="page-v-scroller right-pannel">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
     <app-footer></app-footer>
  </div>
</div>
